import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartSharedModule } from '@spartacus/cart/base/components';
import { CartNotEmptyGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { PromotionsModule } from '@spartacus/storefront';
import { CustomCardModule } from 'src/app/spartacus/custom/shared/components/custom-card/custom-card.module';
import { CustomIconsModule } from '../../../../../../custom/icons/custom-icons.module';
import { CustomCheckoutAuthGuard } from '../../guards/custom-checkout-auth.guard';
import { CustomReviewSubmitComponent } from './custom-review-submit.component';


@NgModule({
  declarations: [CustomReviewSubmitComponent],
  imports: [
    CommonModule,
    CustomCardModule,
    CartSharedModule,
    I18nModule,
    UrlModule,
    RouterModule,
    PromotionsModule,
    CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutReviewOrder: {
          component: CustomReviewSubmitComponent,
          guards: [CustomCheckoutAuthGuard, CartNotEmptyGuard],
        },
      }
    } as CmsConfig),
  ]
})
export class CustomReviewSubmitModule { }
